import { createFileRoute, useSearch } from '@tanstack/react-router'
import { z } from 'zod'
import { AuthLayout } from '@/components/auth/auth-layout'
import { SolicitarRecuperacaoForm } from '@/components/auth/solicitar-recuperacao-form'
import { RedefinirSenhaForm } from '@/components/auth/redefinir-senha-form'

function normalizeRecoveryToken(token: string): string | undefined {
  const trimmed = token.trim()
  if (trimmed.length === 0) return undefined
  // Alguns parseadores serializam string em query com aspas (%22...%22)
  const unquoted = trimmed.replace(/^['"]+|['"]+$/g, '')
  return unquoted.length > 0 ? unquoted : undefined
}

/** Evita depender só do parse do router (número vs string no query). */
function recoveryTokenFromLocationSearch(): string | undefined {
  if (typeof window === 'undefined') return undefined
  const raw = new URLSearchParams(window.location.search).get('t')
  return raw ? normalizeRecoveryToken(raw) : undefined
}

const recuperarSenhaSearchSchema = z.object({
  /**
   * Token do link (`codigo.timestamp`). O router pode entregar como `number`
   * quando o valor parece decimal; normalizamos para string.
   */
  t: z
    .union([z.string(), z.number()])
    .optional()
    .transform((val) => {
      if (val === undefined) return undefined
      const s = typeof val === 'number' ? String(val) : val
      return normalizeRecoveryToken(s)
    }),
})

export const Route = createFileRoute('/recuperar-senha')({
  validateSearch: recuperarSenhaSearchSchema,
  component: RecuperarSenhaPage,
})

function RecuperarSenhaPage() {
  const { t } = useSearch({ from: '/recuperar-senha' })
  const token = recoveryTokenFromLocationSearch() ?? (t ? normalizeRecoveryToken(t) : undefined)

  return (
    <AuthLayout>
      {token ? (
        <RedefinirSenhaForm token={token} />
      ) : (
        <SolicitarRecuperacaoForm />
      )}
    </AuthLayout>
  )
}
